export const DEFAULT_HORIZON = 252
